"use client";

import type {
  QuickPayOutput,
  QuickPayReceiptContext,
} from "@tillix/api-contract/client-schemas";
import { FEE_BY_METHOD } from "@/features/pay/state/payment-fees";
import {
  type QuickPayCardFormValues,
  quickPayCardFormSchema,
} from "../schemas/quick-pay-form";
import { useQuickPayForm } from "./use-quick-pay-form";

interface UseQuickPayCardFormParams {
  tenantId: string;
  externalId: string;
  nameOnAccount?: string;
  zipCode?: string;
  amount: number;
  onSuccess: (result: QuickPayOutput, context: QuickPayReceiptContext) => void;
}

export function useQuickPayCardForm(params: UseQuickPayCardFormParams) {
  return useQuickPayForm<QuickPayCardFormValues>({
    ...params,
    schema: quickPayCardFormSchema,
    defaultValues: {
      cardHolderName: "",
      cardNumber: "",
      expiryMonth: "",
      expiryYear: "",
      cvv: "",
      email: "",
    },
    buildPayload: (values, clientRequestId) => ({
      clientRequestId,
      tenantId: params.tenantId,
      externalId: params.externalId,
      ...(params.nameOnAccount ? { nameOnAccount: params.nameOnAccount } : {}),
      ...(params.zipCode ? { zipCode: params.zipCode } : {}),
      email: values.email,
      amount: params.amount,
      fee: FEE_BY_METHOD.CARD,
      requestType: "card",
      cardDetail: {
        cardNumber: values.cardNumber,
        cvv: values.cvv,
        expiryMonth: values.expiryMonth as `0${number}` | `1${number}`,
        expiryYear: values.expiryYear as `${number}`,
        cardHolderName: values.cardHolderName,
      },
    }),
    buildReceiptContext: (values) => ({
      payerName: values.cardHolderName,
      lastFour: values.cardNumber.slice(-4),
      paymentType: "card",
      email: values.email,
    }),
  });
}
